import React, { PropsWithChildren } from "react";
import { useCurrentProject } from "lib/hooks/useProject";
import AuthGuard from "components/auth/AuthGuard";
import MobileDeviceCheck from "components/mobile/MobileDeviceCheck";
import UploadDialog from "components/modules/UploadDialog/UploadDialog";
import UploadPreprocessorDialog from "components/modules/UploadPreprocessing/Dialog/UploadPreprocessorDialog";
import CesiumViewerAnchor from "../elements/CesiumViewer/CesiumViewerAnchor";
import Header from "./elements/Header/Header";
import SideNav from "./elements/SideNav/SideNav";
import FileDropzoneFullScreen from "./elements/FileDropzoneFullScreen";

export default function SpatialViewerOnlyLayout(p: PropsWithChildren<{}>) {
  const { isProjectOpen } = useCurrentProject();

  let content = (
    <FileDropzoneFullScreen
      className="flex min-h-0 flex-1"
      frostZoneClassName="rounded-xl"
    >
      <div className="relative flex-1 overflow-hidden rounded-xl shadow-1">
        <CesiumViewerAnchor className="absolute inset-0" />
      </div>
    </FileDropzoneFullScreen>
  );

  return (
    <AuthGuard>
      <MobileDeviceCheck>
        <div className="flex h-screen items-stretch gap-4 px-5 py-3">
          {isProjectOpen && <SideNav className="shrink-0" />}
          <div className="flex h-full flex-1 flex-col items-stretch">
            <Header />
            {content}
          </div>
        </div>
        {isProjectOpen && (
          <>
            <UploadDialog />
            <UploadPreprocessorDialog />
          </>
        )}
      </MobileDeviceCheck>
    </AuthGuard>
  );
}
